import { Link } from "react-router-dom";
import WhatsAppLogo from "@/assets/whatsapp.png";

const WHATSAPP_CLAIM_URL =
  "https://wa.me/919324095283?text=Hi%2C%20I%20want%20to%20raise%20a%20request";

const PP_MORI = { fontFamily: "'PP Mori', sans-serif" };
const OUTFIT = { fontFamily: "'Outfit', sans-serif" };

export default function HowItWorks() {
  return (
    <section className="tw-relative tw-bg-white tw-py-10 tw-text-black tw-overflow-hidden">
      {/* phone image sits behind the copy on md+ */}
      <img
        src="/adivaa/HowItWorks.png"
        alt="Claims Process on Phone"
        className="tw-hidden md:tw-block tw-absolute tw-opacity-90 tw-object-contain md:tw-right-0 md:tw-bottom-0 md:tw-w-1/2 md:tw-h-[60%] lg:tw-left-[28.5%] lg:tw-top-10 lg:tw-bottom-auto lg:tw-w-[68%] lg:tw-h-[612px]"
      />

      <div className="tw-relative tw-z-10 tw-w-[90%] md:tw-w-4/5 tw-mx-auto tw-flex tw-flex-col md:tw-min-h-[600px]">
        <h2
          className="tw-text-4xl md:tw-text-5xl md:tw-leading-[48px] tw-text-center tw-font-bold tw-pb-16"
          style={PP_MORI}
        >
          How it works
        </h2>

        <div className="tw-flex-1 tw-flex tw-items-center">
          <div className="tw-w-full md:tw-w-1/2 lg:tw-max-w-[588px] tw-flex tw-flex-col tw-gap-6 tw-items-start">
            <h3
              className="tw-text-3xl md:tw-text-5xl md:tw-leading-[48px] tw-font-bold"
              style={PP_MORI}
            >
              Easy claims, <span className="tw-text-[#f39c12]">smooth service</span>
            </h3>

            <p
              className="tw-max-w-[576px] tw-text-lg md:tw-text-xl tw-leading-7 tw-text-[#1F2937]"
              style={OUTFIT}
            >
              Filing a claim is simple. Share a few details about what
              happened, and our team will review your claim and email you the
              details of your next steps.
            </p>

            {/* buttons shrink on phones so both fit side by side */}
            <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-3 md:tw-gap-4">
              <Link
                to="/customer-login"
                className="tw-rounded-full tw-bg-[#f39c12] tw-px-6 tw-py-3 md:tw-px-8 md:tw-py-4 tw-text-base md:tw-text-lg tw-leading-6 md:tw-leading-7 tw-font-bold tw-text-white tw-no-underline tw-shadow-[0_10px_15px_-3px_rgba(249,115,22,0.2),0_4px_6px_-4px_rgba(249,115,22,0.2)] hover:tw-bg-black tw-transition-colors"
                style={PP_MORI}
              >
                Start a Claim
              </Link>

              <a
                href={WHATSAPP_CLAIM_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="tw-flex tw-items-center tw-gap-2 md:tw-gap-2.5 tw-rounded-full tw-border-[1.5px] tw-border-[#f39c12] tw-bg-white tw-pl-5 tw-pr-6 tw-py-3 md:tw-pl-7 md:tw-pr-8 md:tw-py-4 tw-text-[#f39c12] tw-no-underline tw-shadow-[0_10px_15px_-3px_rgba(249,115,22,0.2),0_4px_6px_-4px_rgba(249,115,22,0.2)] hover:tw-bg-[#fff7ed] tw-transition-colors"
              >
                <img
                  src={WhatsAppLogo}
                  alt="WhatsApp"
                  width={22}
                  height={22}
                  className="tw-h-5 tw-w-5 md:tw-h-[22px] md:tw-w-[22px] tw-shrink-0 tw-object-contain"
                />
                <span className="tw-text-base md:tw-text-lg tw-leading-6 md:tw-leading-7 tw-font-bold" style={OUTFIT}>
                  Quick Claim
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
